











import { defineComponent, ref, Ref } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    url: {
      type: String,
      required: true,
    },
  },

  setup() {
    const isLoaded: Ref<boolean> = ref(false)

    const onImgLoad = () => {
      isLoaded.value = true
    }

    return {
      isLoaded,
      onImgLoad,
    }
  },
})
